export default {
    namespaced: true,
    state: {
        value: null,
        certNumber: '',
    },
    getters: {
        getOptions(state) {
            return state.options;
        },
        getValue(state) {
            return state.value;
        },
        isValid(state) {
            return Boolean(state.value);
        }
    },
    mutations: {
        setPaymentOption(state, payload) {
            state.value = payload;
        },
        setCertNumber(state, payload) {
            state.certNumber = payload;
        }
    },
    actions: {
        setPaymentOption({commit, dispatch}, payload) {
            commit('setPaymentOption', payload);
            dispatch('config/saveStateToLocalStorage', null, {root: true});
        },
        setCertNumber({commit}, payload) {
            commit('setCertNumber', payload);
        }
    }
}
